import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import {
  CommandMenuType,
  IPosUiMenu,
  IPosUiState as IPosUiMenuState,
} from '../../interfaces/states/IPosUiMenuState';

const initialState: IPosUiMenuState = {
  User: {
    menuType: CommandMenuType.User,
    commands: [],
  },
  General: {
    menuType: CommandMenuType.General,
    commands: [],
  },
  Customer: {
    menuType: CommandMenuType.Customer,
    commands: [],
  },
  Focus: {
    menuType: CommandMenuType.Focus,
    commands: [],
  },
  Info: {
    menuType: CommandMenuType.Info,
    commands: [],
  },
  Popular: {
    menuType: CommandMenuType.Popular,
    commands: [],
  },
  LogOff: {
    menuType: CommandMenuType.LogOff,
    commands: [],
  },
};

class PosUiMenuReducer extends ImmerReducer<IPosUiMenuState> {
  public set(configuration: IPosUiMenu): void {
    this.draftState[configuration.menuType] = configuration;
  }
}

export const PosUiMenuActions = createActionCreators(PosUiMenuReducer);
export const PosUiMenuReducerFunction = createReducerFunction(PosUiMenuReducer, initialState);
